<template>
  <div class="container">
    <div class="page">
      <div>
        <img src="../assets/images/callme.png">
      </div>
      <div class="b_intro">
        <div class="s_title">简介：</div>
        <div>
          深圳市德力诚信科技有限公司是一家专业线束设计、加工企业，产品主要应用于汽车、家电、医疗、工业电器等各个领域。公司拥有各类线束的自主设计能力，可以按照客户设计要求进行加工生产。同时具备PCB设计能力，提供PCBA加工制造服务。为确保产品质量，公司建立了完善的质量检测体系，确保为客户提供质量可靠的优质产品。
        </div>
      </div>
      <div>
        <el-dialog
          :visible.sync="dialogVisible"
          width="760px"
          custom-class="dialog"
          :close-on-click-modal="false"
        >
          <div class="msg">
            <div>联系我们：<span @click="dialogVisible = false">×</span></div>
            <div>
              <div>
                <div>姓名 *</div>
                <input v-model="username">
              </div>
              <div>
                <div>邮箱 *</div>
                <input v-model="email">
              </div>
              <div>
                <div>公司</div>
                <input v-model="company">
              </div>
              <div>
                <div>手机号 *</div>
                <input v-model="mobile">
              </div>
              <div>
                <div>留言</div>
                <textarea name="" id="" cols="34" rows="3" v-model="messageDesc"></textarea>
              </div>
            </div>
            <div>
              <button @click="addMsg">提交</button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      username:'',
      email:'',
      mobile:'',
      company:'',
      messageDesc:''
    };
  },
  methods: {
    addMsg() {
      this.dialogVisible = false;
      var username = this.username;
      var email = this.email;
      var company = this.company;
      var mobile = this.mobile;
      var messageDesc = this.messageDesc;
      // ajax请求
      var url = "tyMessage/saveMessage";
      var obj = {username,email,mobile,company,messageDesc};
      this.axios.post(url,this.qs.stringify(obj))
      .then(res=>{
        console.log(res.data)
        if(res.data.code==0){
          this.$message({
            type: 'info',
            message:'提交成功'
          });
        } else {
          this.$message({
            type: 'info',
            message:'提交失败'
          });
        }
      })
    }
  }
}
</script>


<style scoped>
/* 页头 */
.b_intro {
  text-align: left;
  margin-top: 32px;
  margin-bottom: 38px;
  line-height:32px;
  font-size: 14px;
}
/* 联系我们 */
.callme {
  text-align: left;
}
.s_title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  display: flex;
}
.callme>div:nth-child(2) {
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
}
/* 图标 */
.msg_img {
  width: 20px;
  height: 20px;
  overflow: hidden;
  position: relative;
  margin-left: 12px;
  margin-top: 2px;
}
.msg_img>img {
  width: 45px;
  height: 65px;
  position: absolute;
  left: -16px;
  top: -10px;
}
.msg_img>img:hover {
  top: -32px;
}
/* 留言框 */
.msg {
  width: 540px;
  height: 582px;
  text-align: left;
  box-shadow:0px 5px 12px 4px rgba(119,119,119,0.09);
  margin-right: 0 !important;
}
.msg>div {
  padding-left: 18px;
  padding-right: 18px;
  margin-bottom: 12px;
}
.msg>div:first-child {
  height: 52px;
  background-color: #000;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  line-height: 52px;
}
.msg>div:first-child>span {
  position: absolute;
  right: 18px;
  font-size: 24px;
  cursor: default;
}
.msg>div:nth-child(2)>div {
  height: 66px;
  font-size: 14px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height: 24px;
  margin-bottom: 12px;
  margin-right: 18px;
}
.msg>div:nth-child(2)>div:last-child {
  margin-bottom: 14px;
}
.msg>div:nth-child(2)>div>div:first-child {
  margin-bottom: 6px;
}
.msg>div:nth-child(2)>div>input {
  width:100%;
  height:36px;
  border-radius:2px;
  border:1px solid rgba(151,151,151,1);
  padding-left: 18px;
  font-weight: 14px;
}
.msg>div:nth-child(2)>div>textarea {
  width: 468px;
  height: 110px;
  border-radius:2px;
  border:1px solid rgba(151,151,151,1);
  outline: 0;
  padding: 0 18px;
  font-weight: 14px;
  line-height: 24px;
  overflow: auto;
}
.msg button {
  width:140px;
  height:36px;
  background:rgba(0,0,0,1);
  border-radius:28px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-left: 182px;
  z-index: 1;
  position: absolute;
  bottom: 16px;
}
.page /deep/ .dialog {
  width: 540px !important;
  height: 582px;
}
.page /deep/ .el-dialog__header {
  display: none;
}
.page /deep/ .el-dialog__body {
  padding: 0;
  width: 540px;
  margin-right: 0 !important;
}
</style>